"use client";

import { TermsContent } from "@/components/legal/TermsContent";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TermsModal = ({ isOpen, onClose }: TermsModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Termos e Condições</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-700 max-h-[70vh] overflow-y-auto pr-2">
          <TermsContent withPageTitle={false} />
        </div>

        <DialogFooter className="flex flex-col gap-2">
          <Button onClick={() => window.open("/termos", "_blank")}>
            Abrir página completa
          </Button>
          <Button variant="border" onClick={onClose} className="">
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsModal;
